export default __webpack_public_path__ + "7d79a567e4968053b420a022ab3a212d.jpg";